import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKnopLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	fill: "currentColor",
	stroke: "currentColor",
	strokeWidth: "0.4px",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#FFC70F",
		d: "M0 6a6 6 0 0 1 6-6h28a6 6 0 0 1 6 6v28a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#253A7C",
		d: "m36.22 32.81-9.97-14.25 8.24-11.84a1.1 1.1 0 0 0-1.8-1.25l-7.85 11.3a8 8 0 0 0-2.48-1.75l5.8-8.3a1.1 1.1 0 0 0-1.8-1.25l-6.07 8.7q-.09.12-.13.27a8 8 0 0 0-.89-.05h-1.71v-8.3a1.1 1.1 0 0 0-2.2 0v13.59H11.6V6.09a1.1 1.1 0 0 0-2.19 0v8.38a6.43 6.43 0 0 0 0 12.67v6.3a1.1 1.1 0 0 0 2.2 0v-6.22h3.76v6.22a1.1 1.1 0 0 0 2.19 0v-6.22h.71c1.4 0 2.71-.83 3.7-1.84l6.05 8.68a1.1 1.1 0 1 0 1.8-1.25L22.6 22.46v-.02c-1.25-1.7-2.44-2.77-4.58-2.77h-.46v-3.1h1.71q2.86 0 4.7 2.56l10.46 14.94a1.1 1.1 0 1 0 1.79-1.26m-15.53-9.26c-.77.9-1.7 1.48-2.42 1.48h-7.85a4.23 4.23 0 0 1-1-8.33v4.07c0 .6.48 1.1 1.09 1.1H18c.97 0 1.6.24 2.68 1.68"
	})]
});
export default SvgKnopLogo;
